import {
    SET_BATCH_SIMPLE_LIST_ITEM,
    TOGGLE_BATCH_SIMPLE_LIST,
} from '../types'
import _cloneDeep from 'lodash/cloneDeep'


export default (state = {}, action = {}) => {
    const newState = _cloneDeep(state)
    const identifier = action.identifier

    switch(action.type) {
        case TOGGLE_BATCH_SIMPLE_LIST:
            if(typeof newState[identifier] == "undefined"){
                newState[identifier] = {
                    open: false,
                    ids: []
                }
            }
            newState[identifier].open = !newState[identifier].open
            if(!newState[identifier].open){
                newState[identifier].ids = []
            }

            return newState
        case SET_BATCH_SIMPLE_LIST_ITEM:
            if(identifier && typeof newState[identifier] == "undefined"){
                newState[identifier] = {
                    open: true,
                    ids: [action.id]
                }
            }else{
                if(action.id){
                    const index = newState[identifier].ids.findIndex(i => i == action.id)
                    if(index > -1){
                        newState[identifier].ids.splice(index, 1)
                    }else{
                        newState[identifier].ids.push(action.id)
                    }
                }else{
                    newState[identifier].ids = []
                    newState[identifier].open = false
                }
            }

            return newState
        default:
            return state
    }
}